import { track as analyticsTrack, identify as analyticsIdentify } from '@fff-web/fff-analytics';
import { v4 as uuidv4 } from 'uuid';

const UUID_LOCAL_STORAGE_KEY = 'FFF_gtb_uuid';

const isExperimentRunning = ({ optimizelyDecision }) => {
  const isFeatureFlagEnabled = optimizelyDecision.enabled;
  const regex = /^default-rollout-\d+-\d+$/;
  const isRunning = !!optimizelyDecision.ruleKey && !regex.test(optimizelyDecision.ruleKey);
  return isFeatureFlagEnabled && isRunning;
};

const getUUID = () => {
  const uuidFromLocalStorage = localStorage.getItem(UUID_LOCAL_STORAGE_KEY);
  if (!uuidFromLocalStorage) {
    localStorage.setItem(UUID_LOCAL_STORAGE_KEY, uuidv4());
  }
  return localStorage.getItem(UUID_LOCAL_STORAGE_KEY) || '';
};

const track = (name, experimentData) => {
  analyticsTrack({
    trackName: name,
    properties: experimentData,
    options: {
      Optimizely: {
        userId: getUUID(),
      },
    },
  });
};

const identify = (experimentData) => {
  analyticsIdentify({
    traits: experimentData,
    options: {
      Optimizely: {
        userId: getUUID(),
      },
    },
  });
};
export { isExperimentRunning, getUUID, UUID_LOCAL_STORAGE_KEY, track, identify };
